import http from "../http-common";

class VilleService{
    getAll() {
        return http.get("/widget_liste_ville.php");
    }
}

export default new VilleService();